export function getTenantData() {
    return new Promise(async (resolve, reject) => {
        let tenant =
            undefined != localStorage.getItem("tenant") &&
            null !== localStorage.getItem("tenant") &&
            "" != localStorage.getItem("tenant");
        resolve(tenant);
    });
}
